import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/skype': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M424.7 299.8C427.6 285.8 429.4 270.9 429.4 256 429.4 142.5 337.5 50.7 224.1 50.7 209.2 50.7 194.4 52.4 180.3 55.4 161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144 0 169.7 8.7 193.3 23.3 212.2 20.4 226.2 18.6 241.1 18.6 256 18.6 369.5 110.5 461.3 223.9 461.3 238.8 461.3 253.6 459.6 267.7 456.6 286.7 471.2 310.3 479.9 335.9 479.9 397.7 479.9 447.9 429.7 447.9 367.9 448 342.3 439.3 318.7 424.7 299.8zM230.1 391.3C164.5 391.3 109.6 362.1 109.6 326.3 109.6 310.3 118.6 295.7 139.1 295.7 170.3 295.7 173.2 340.6 227.2 340.6 252.9 340.6 269.5 329.2 269.5 314.3 269.5 295.6 253.5 292.7 227.5 286.3 165 270.9 109.7 264.3 109.7 199.1 109.7 139.9 168.3 118 218.8 118 273.9 118 329.6 139.9 329.6 173.4 329.6 190.3 318.2 205.2 299.3 205.2 271 205.2 270.1 171.7 224.3 171.7 198.6 171.7 182.3 178.7 182.3 194.2 182.3 214 203.1 216 251.4 227.2 292.8 236.5 342.1 254 342.1 304.8 342.1 363.9 285 391.3 230.1 391.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/skype.js
// module id = 2Aql
// module chunks = 144